import { Skeleton } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import instance from "../../../api/interceptor";
import "../../../components/Milestone/mileston.css";
import Nodata from "../../../components/Nodata";
import { API_PATH } from "../../../constant/apiPath";
import { Date, Time } from "../../../utils/moment";
import { withTranslation } from "react-i18next";

const Milestone = (props) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [milestonedata, setMilestonedata] = useState([]);
  const [transportMilestones, setTransportMilestone] = useState([]);
  const [terminalMilestones, setTerminalMilestone] = useState([]);
  const [cabotageMilestones, setCabotageMilestone] = useState([]);
  const controller = new AbortController();
  const signal = controller.signal;
  const [checkAbort, setCheckAbort] = useState(false);
  const { t } = props;
  const shipmentType = location?.state?.item?.type;
  const getMilestone = () => {
    setLoading(true);
    instance
      .get(
        `${API_PATH.MILESTONE_PROCESS}${location?.state?.item?.ShipmentID}`,
        {
          signal,
        },
      )
      .then((res) => {
        setLoading(false);
        if (res._IsSuccess) {
          if (res?._Data?.routingTimeLine) {
            setMilestonedata(res?._Data?.routingTimeLine?.eventNodes ?? []);
          }
        } else {
          setMilestonedata([]);
        }
      })
      .catch((err) => {
        if (!checkAbort) setLoading(false);

        setMilestonedata([]);
        console.log("Get milestone api in process fail", err);
      });
  };
  const getMilestoneTransport = (i) => {
    setLoading(true);
    const url = `${API_PATH.MILESTONE_TRANSPORT_PROCESS}?transportid=${i}`;
    instance
      .get(url)
      .then((res) => {
        if (res._IsSuccess) {
          setTransportMilestone(res?._Data?.transportMilestones ?? {});
        } else {
          setTransportMilestone({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setTransportMilestone({});
        setLoading(false);
        console.log("Get transport milestone error", err);
      });
  };
  const getMilestoneTerminal = (i) => {
    setLoading(true);
    const url = `${API_PATH.MILESTONE_TERMINAL_PROCESS}?shipmentid=${i}`;
    instance
      .get(url)
      .then((res) => {
        if (res._IsSuccess) {
          setTerminalMilestone(res?._Data?.terminalMilestones ?? {});
        } else {
          setTerminalMilestone({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setTerminalMilestone({});
        setLoading(false);
        console.log("Get terminal milestone error", err);
      });
  };
  const getMilestoneCabotage = (i) => {
    const url = `${API_PATH.MILESTONE_CABOTAGE_PROCESS}?shipmentid=${i}`;
    instance
      .get(url)
      .then((res) => {
        if (res._IsSuccess) {
          setCabotageMilestone(res?._Data ?? {});
        } else {
          setCabotageMilestone({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setCabotageMilestone({});
        setLoading(false);
        console.log("Get cabotage milestone error", err);
      });
  };
  useEffect(() => {
    if (location?.state?.item?.ShipmentID !== undefined) getMilestone();

    return () => {
      setCheckAbort(true);
      return controller.abort();
    };
  }, [location]);
  useEffect(() => {
    const type = location?.state?.item?.type;
    const shipmentId = location?.state?.item?.ShipmentID;

    if (shipmentId && !["Shipment", "Terminal"].includes(type)) {
      getMilestoneTransport(shipmentId);
    }
  }, [location?.state?.item?.ShipmentID]);
  useEffect(() => {
    const type = location?.state?.item?.type;
    const shipmentId = location?.state?.item?.ShipmentID;
    if (type === "Terminal") {
      getMilestoneTerminal(shipmentId ?? "");
    }
  }, [location?.state?.item?.ShipmentID]);
  
  useEffect(() => {
    const type = location?.state?.item?.type;
    const shipmentId = location?.state?.item?.ShipmentID;
    if (type == "Cabotage") {
      getMilestoneCabotage(shipmentId ?? "");
    }
  }, [location?.state?.item?.type, location?.state?.item?.ShipmentID]);

  return (
    <React.Fragment>
      {loading ? (
        <Skeleton
          variant="rectangular"
          height={611}
          style={{ width: "100%", marginBottom: "1rem" }}
        />
      ) : shipmentType === "Shipment" ? (
        <div className="milestone-section">
          {milestonedata.length ? (
            <>
              {milestonedata.map((item, index) => {
                return (
                  <div className="milestone-div" key={index}>
                    <div className="milestone-div-child pt-3">
                      {item?.nameId === "Arrival_At_Destination" ||
                      item?.nameId === "Arrival_At_Destination_air" ||
                      item?.nameId === "Arrival_At_Destination_roa" ? (
                        <p className="hour">
                          {/* {item?.ataDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.ataDate ?? item?.etaDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          <>{Time(item?.ataDate ?? item?.etaDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "Dept_From_First_Load_Port" ||
                        item?.nameId === "Dept_From_First_Load_Port_air" ||
                        item?.nameId === "Dept_From_First_Load_Port_roa" ? (
                        <p className="hour">
                          {/* {item?.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "CE_Mercante_Clearance" ? (
                        <p className="hour">
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "Cargo_Ready" ? (
                        <p className="hour">
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "Pick_up" ? (
                        <p className="hour">
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "In_Transit" ? (
                        <p className="hour">
                          {/* {item.atdDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etaDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "Shipment_Authorization" ? (
                        <p className="hour">
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "load" ? (
                        <p className="hour">
                          <>{Time(item?.atdDate ?? item?.etdDate ?? null)}</>
                        </p>
                      ) : item?.nameId === "unload" ? (
                        <p className="hour">
                          <>{Time(item?.ataDate ?? item?.etaDate ?? null)}</>
                        </p>
                      ) : null}
                    </div>
                    <div
                      className="milestone-div-child"
                      style={{ width: "12%" }}
                    >
                      <div
                        className="circle"
                        style={{
                          backgroundColor: item.milestoneColor,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.milestoneIconPath && (
                          <img
                            src={item.milestoneIconPath}
                            alt={item.eventName}
                            height={32}
                            width={32}
                            style={{ objectFit: "contain" }}
                          />
                        )}
                      </div>
                      {index !== milestonedata.length - 1 ? (
                        <div
                          className="milestone-line"
                          style={{
                            backgroundColor: item.milestoneColor,
                            height: "70px",
                          }}
                        />
                      ) : null}
                    </div>
                    <div className="milestone-div-child pt-3 milestone-right-side">
                      <p
                        className="status-name"
                        style={{ color: item.milestoneColor }}
                      >
                        {t(item?.eventName) ?? "NA"}
                      </p>
                      {item?.nameId === "Arrival_At_Destination" ||
                      item?.nameId === "Arrival_At_Destination_air" ||
                      item?.nameId === "Arrival_At_Destination_roa" ? (
                        <p className="status-year">
                          {/* {item?.ataDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.ataDate ?? item?.etaDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          {item?.ataDate === null ? (
                            <>{Date(item?.etaDate ?? null)}</>
                          ) : (
                            <>{Date(item?.ataDate ?? null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "Dept_From_First_Load_Port" ||
                        item?.nameId === "Dept_From_First_Load_Port_air" ||
                        item?.nameId === "Dept_From_First_Load_Port_roa" ? (
                        <p className="status-year">
                          {/* {item?.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          {item?.atdDate === null ? (
                            <>{Date(item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(item?.atdDate ?? null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "CE_Mercante_Clearance" ? (
                        <p className="status-year">
                          {item.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "Cargo_Ready" ? (
                        <p className="status-year">
                          {item.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "Pick_up" ? (
                        <p className="status-year">
                          {item.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "In_Transit" ? (
                        <p className="status-year">
                          {/* {item.atdDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etaDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )} */}
                          {item?.atdDate === null ? (
                            <>{Date(item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(item?.atdDate ?? null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "Shipment_Authorization" ? (
                        <p className="status-year">
                          {item.atdDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "load" ? (
                        <p className="status-year">
                          {item.atdDate !== "" && item?.etdDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : item?.nameId === "unload" ? (
                        <p className="status-year">
                          {item.ataDate !== "" && item?.etaDate !== "" ? (
                            <>{Date(item?.atdDate ?? item?.etdDate ?? null)}</>
                          ) : (
                            <>{Date(null)}</>
                          )}
                        </p>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <Nodata text="Milestone not found" />
          )}
        </div>
      ) : shipmentType === "Terminal" ? (
        <div className="milestone-section">
          {terminalMilestones.length ? (
            <>
              {terminalMilestones.map((item, index) => (
                <div className="milestone-div" key={index}>
                  <div className="milestone-div-child pt-3">
                    <p className="hour">
                      <>{item.date ? Time(item.date) : Time(null)}</>
                    </p>
                  </div>

                  <div className="milestone-div-child" style={{ width: "12%" }}>
                    {/* Milestone icon and color */}
                    <div
                      className="circle"
                      style={{
                        backgroundColor: item.milestoneColor,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.milestoneIconPath && (
                        <img
                          src={item.milestoneIconPath}
                          alt={item.eventName}
                          height={40}
                          width={40}
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>

                    {/* Display line between milestones if not the last item */}
                    {index !== terminalMilestones.length - 1 && (
                      <div
                        className="milestone-line"
                        style={{
                          backgroundColor: item.milestoneColor,
                          height: "70px",
                        }}
                      />
                    )}
                  </div>

                  <div className="milestone-div-child pt-3 milestone-right-side">
                    <p
                      className="status-name"
                      style={{ color: item.milestoneColor }}
                    >
                      {item.eventName ?? "NA"}
                    </p>

                    {/* Display Date for the milestone */}
                    <p className="status-year">
                      {item.date ? Date(item.date) : Date(null)}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <Nodata text="Milestone not found" />
          )}
        </div>
      ) : shipmentType === "Transport" ? (
        <div className="milestone-section">
          {transportMilestones.length ? (
            <>
              {transportMilestones.map((item, index) => (
                <div className="milestone-div" key={index}>
                  <div className="milestone-div-child pt-3">
                    {/* <p className="hour">
        <>{item.date ? Time(item.date) : Time(null)}</>
      </p> */}
                  </div>

                  <div className="milestone-div-child" style={{ width: "12%" }}>
                    {/* Milestone icon and color */}
                    <div
                      className="circle"
                      style={{
                        backgroundColor: item.milestoneColor,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.milestoneIconPath && (
                        <img
                          src={item.milestoneIconPath}
                          alt={item.eventName}
                          height={32}
                          width={32}
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>

                    {/* Display line between milestones if not the last item */}
                    {index !== transportMilestones.length - 1 && (
                      <div
                        className="milestone-line"
                        style={{
                          backgroundColor: item.milestoneColor,
                          height: "70px",
                        }}
                      />
                    )}
                  </div>

                  <div className="milestone-div-child pt-3 milestone-right-side">
                    <p
                      className="status-name"
                      style={{ color: item.milestoneColor }}
                    >
                      {item.eventName ?? "NA"}
                    </p>

                    {/* Display Date for the milestone */}
                    <p className="status-year">
                      {item.date ? Date(item.date) : Date(null)}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <Nodata text="Milestone not found" />
          )}
        </div>
      ) : shipmentType === "Cabotage" ? (
        <div className="milestone-section">
          {cabotageMilestones.length ? (
            <>
              {cabotageMilestones.map((item, index) => (
                <div className="milestone-div" key={index}>
                  <div className="milestone-div-child pt-3">
                    <p className="hour">
                      {item.date ? Time(item.date) : Time(null)}
                    </p>
                  </div>
                  <div className="milestone-div-child" style={{ width: "12%" }}>
                    {/* Milestone icon and color */}
                    <div
                      className="circle"
                      style={{
                        backgroundColor: item.milestoneColor,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.milestoneIconPath && (
                        <img
                          src={item.milestoneIconPath}
                          alt={item.eventName}
                          height={32}
                          width={32}
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>

                    {/* Display line between milestones if not the last item */}
                    {index !== cabotageMilestones.length - 1 && (
                      <div
                        className="milestone-line"
                        style={{
                          backgroundColor: item.milestoneColor,
                          height: "70px",
                        }}
                      />
                    )}
                  </div>

                  <div className="milestone-div-child pt-3 milestone-right-side">
                    <p
                      className="status-name"
                      style={{ color: item.milestoneColor }}
                    >
                      {item.eventName ?? "NA"}
                    </p>

                    {/* Display Date for the milestone */}
                    <p className="status-year">
                      {item.date ? Date(item.date) : Date(null)}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <Nodata text="Milestone not found" />
          )}
        </div>
      ) : (
        <div className="milestone-section">
          {transportMilestones.length ? (
            <>
              {transportMilestones.map((item, index) => (
                <div className="milestone-div" key={index}>
                  <div className="milestone-div-child pt-3">
                    {/* <p className="hour">
        <>{item.date ? Time(item.date) : Time(null)}</>
      </p> */}
                  </div>

                  <div className="milestone-div-child" style={{ width: "12%" }}>
                    {/* Milestone icon and color */}
                    <div
                      className="circle"
                      style={{
                        backgroundColor: item.milestoneColor,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.milestoneIconPath && (
                        <img
                          src={item.milestoneIconPath}
                          alt={item.eventName}
                          height={32}
                          width={32}
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>

                    {/* Display line between milestones if not the last item */}
                    {index !== transportMilestones.length - 1 && (
                      <div
                        className="milestone-line"
                        style={{
                          backgroundColor: item.milestoneColor,
                          height: "70px",
                        }}
                      />
                    )}
                  </div>

                  <div className="milestone-div-child pt-3 milestone-right-side">
                    <p
                      className="status-name"
                      style={{ color: item.milestoneColor }}
                    >
                      {item.eventName ?? "NA"}
                    </p>

                    {/* Display Date for the milestone */}
                    <p className="status-year">
                      {item.date ? Date(item.date) : Date(null)}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <Nodata text="Milestone not found" />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(Milestone);
